import type { FunctionComponent, MouseEvent, MouseEventHandler } from 'react'
import React from 'react'

import { TraverseButton } from '../../../../TraverseButton'
import styles from './styles.module.scss'

export const Buttons: FunctionComponent<Props> = ({
  current,
  total,
  onChange,
  traverseGalleryHandler,
}) => {
  const handlePrevious = (e: MouseEvent<HTMLButtonElement>) => {
    traverseGalleryHandler && traverseGalleryHandler(e)
    onChange(current - 1)
  }
  const handleNext = (e: MouseEvent<HTMLButtonElement>) => {
    traverseGalleryHandler && traverseGalleryHandler(e)
    onChange(current + 1)
  }
  const LABEL_SUFFIX = 'image'

  return (
    <>
      <div className={styles.buttonBack}>
        <TraverseButton
          disabled={current === 0}
          labelSuffix={LABEL_SUFFIX}
          direction="previous"
          onClick={handlePrevious}
        />
      </div>
      <div className={styles.buttonNext}>
        <TraverseButton
          disabled={current === total - 1}
          labelSuffix={LABEL_SUFFIX}
          direction="next"
          onClick={handleNext}
        />
      </div>
    </>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  /**
   * Number for current page
   */
  current: number
  /**
   * Number for total pages
   */
  total: number
  /**
   * Function to handle click
   */
  onChange: (num: number) => void
  /**
   * Event handler that is invoked when traversing gallery images using the next/previous buttons.
   */
  traverseGalleryHandler?: MouseEventHandler<HTMLButtonElement>
}
